"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RescheduleSideDrawer = exports.WithModalHeaderArgs = exports.DefaultRescheduleActivityArgs = void 0;
var material_1 = require("@mui/material");
var react_1 = __importDefault(require("react"));
var il_button_common_1 = require("../il-button/il-button.common");
var il_temporary_drawer_1 = require("../il-temporary-drawer/il-temporary-drawer");
var reschedule_activity_1 = require("./reschedule-activity");
exports.DefaultRescheduleActivityArgs = {
    startedDate: new Date(2022, 4, 12),
    averageAssignmentsPerDay: 2,
    activityDescription: 'World Geography',
    onSubmit: function (args) { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
        return [2 /*return*/, console.log(args)];
    }); }); },
};
exports.WithModalHeaderArgs = __assign(__assign({}, exports.DefaultRescheduleActivityArgs), { showModalHeader: true });
function RescheduleSideDrawer(props) {
    var _a;
    function ChildrenComponent(_a) {
        var _this = this;
        var onClose = _a.onClose;
        return (react_1.default.createElement(material_1.Box, { sx: __assign({ p: '1rem 1.5rem 0', height: '100%', backgroundColor: 'background.default' }, props.sx) },
            react_1.default.createElement(reschedule_activity_1.RescheduleActivityForm, __assign({}, props.rescheduleActivityProps, { onSubmit: function (values) { return __awaiter(_this, void 0, void 0, function () {
                    var _a;
                    return __generator(this, function (_b) {
                        switch (_b.label) {
                            case 0: return [4 /*yield*/, ((_a = props.rescheduleActivityProps) === null || _a === void 0 ? void 0 : _a.onSubmit(values))];
                            case 1:
                                _b.sent();
                                onClose && onClose();
                                return [2 /*return*/];
                        }
                    });
                }); } }))));
    }
    return (react_1.default.createElement(il_temporary_drawer_1.ILTemporaryDrawer, __assign({ clickableComponent: ((_a = props.drawerProps) === null || _a === void 0 ? void 0 : _a.clickableComponent) || react_1.default.createElement(il_button_common_1.RescheduleButton, null), showClose: true }, props === null || props === void 0 ? void 0 : props.drawerProps),
        react_1.default.createElement(ChildrenComponent, null)));
}
exports.RescheduleSideDrawer = RescheduleSideDrawer;
